import { API_BASE } from "../../../utils/baseapiurl";

class SettingsAPI {
	async finalizeImportBOB(payload) {
		try {
			const response = await fetch(`${API_BASE}/finalize-bob`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				body: JSON.stringify(payload),
				credentials: "include",
			});

			const data = await response.json();
			if (!response.ok) {
				throw new Error(data.message || "Failed to solve/update conflicts ");
			}
			return data;
		} catch (error) {
			console.error("Something went wrong:", error);
			throw error;
		}
	}
}

export default new SettingsAPI();
